// import React from 'react'
// import TabComponent from '../TabComponent'
// import { useDispatch } from 'react-redux';
// import { setHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
// import { IoMdTime } from 'react-icons/io';
// import { FaRegCheckCircle } from 'react-icons/fa';
// import TotalPendingRegisration from './TotalPendingRegisration';
// import TotalApprovedRegistration from './TotalApprovedRegistration';

// const TotalPaymentReceivedTabs = () => {
//     const dispatch = useDispatch();

//     React.useEffect(() => {
//         dispatch(setHeaderName("Total Registration"));
//     }, []);

//     const tabsHeadData = [
//         { label: 'Pending', icon: <IoMdTime /> },
//         { label: 'Approved', icon: <FaRegCheckCircle /> },
//     ];
//     const tabsComponent = [<TotalPendingRegisration />, <TotalApprovedRegistration />]

//     return (
//         <div>
//             <TabComponent />
//         </div>
//     )
// }

// export default TotalPaymentReceivedTabs

import React from 'react';
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { IoMdTime } from 'react-icons/io';
import { FaRegCheckCircle } from 'react-icons/fa';
import TabComponent from '../TabComponent';
import TotalPendingRegisration from './TotalNetBankingPaymentReceived';
import TotalApprovedRegistration from './TotalCashPaymentReceived';
import TotalCashPaymentReceived from './TotalCashPaymentReceived';
import TotalNetBankingPaymentReceived from './TotalNetBankingPaymentReceived';

const TotalPaymentReceivedTabs = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setHeaderName("Total Payment Received"));
    }, [dispatch]);

    const tabsHeadData = [
        { label: 'Cash', icon: "" },
        { label: 'Net Banking', icon: "" },
    ];

    const tabsComponent = [
        <TotalCashPaymentReceived />,
        <TotalNetBankingPaymentReceived />,
    ];

    return (
        <div>
            <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
        </div>
    );
};

export default TotalPaymentReceivedTabs;
